export const zIndexBase = 0;
const above = 1;
export const zAboveBase = above + zIndexBase;
export const zLayoutFooter = above + zIndexBase;
export const zLayoutModal = above + zAboveBase;
export const zLayoutModalBackDrop = above + zAboveBase + zIndexBase;
export const zLayoutPopUp = above + zLayoutModal;
//# sourceMappingURL=zIndex.js.map